import SBEditable from "../../../components/sbEditable/sbEditable"
import { ArticlePanelOptionsToClasses } from "../articlePanelHelpers"
import styles from "./riddleembed.module.scss"

function RiddleEmbed({ blok }) {
  return (
    <SBEditable blok={blok} withClass={ArticlePanelOptionsToClasses(blok)}>
      <div className={`div-align-${blok.alignment || "left"} ${styles.riddleembed}`} style={{maxWidth: blok.maxwidth ? `${blok.maxwidth}px` : 520}}>
        <div className={styles.riddleContent} dangerouslySetInnerHTML={{__html: blok.riddle}} />
      </div>
    </SBEditable>
  )
}

export default RiddleEmbed